export default __webpack_public_path__ + "static/media/truck_2_2.29ef69e5.svg";